import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";
import {MONEY_BACK_POLICY, PRIVACY_POLICY, TERMS_OF_USE} from "../../../../../enum/NavigationEnum";

export const PcAgeRange = ({ clickNext = () => {}, clickPrev = () => {}, setDisplayNav = () => {} }) => {
  return (
    <div className="pc-age-range" data-model-id="16859:223">
      <div className="contents">
        <div className="title">
          <div className="heading">Intermittent Fasting</div>

          <div className="text">
            <div className="subtitle">BASED ON YOUR AGE</div>

            <div className="quiz-info">1-minute quiz</div>
          </div>
        </div>

        <div className="frame">
          <div className="card" onClick={() => {clickNext("16-29")}}>
            <div className="age-wrapper">
              <div className="pc-age-range-age">
                <div className="text-wrapper">Age:16~29</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/pc/frame-3.svg" alt="Frame" className="img" />
              </div>
            </div>

            <div className="img-2">
              <Image src="/static/image/questionnaire/fasting/ageRange/pc/image-fx-2025-05-22t104844-973-1.png" alt="Image fx" className="image-fx" />
            </div>
          </div>

          <div className="card" onClick={() => {clickNext("30-39")}}>
            <div className="age-wrapper">
              <div className="pc-age-range-age">
                <div className="text-wrapper">Age: 30~39</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/pc/frame-3.svg" alt="Frame" className="img" />
              </div>
            </div>

            <Image src="/static/image/questionnaire/fasting/ageRange/pc/img35-49.png" alt="Img" className="img-2" />
          </div>

          <div className="card" onClick={() => {clickNext("40-49")}}>
            <div className="age-wrapper">
              <div className="pc-age-range-age">
                <div className="text-wrapper">Age: 40~49</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/pc/frame-3.svg" alt="Frame" className="img" />
              </div>
            </div>

            <div className="img-2">
              <Image src="/static/image/questionnaire/fasting/ageRange/pc/image-fx-2025-05-22t100521-563-1.png" alt="Image fx" className="image-fx-2" />
            </div>
          </div>

          <div className="card" onClick={() => {clickNext("50+")}}>
            <div className="age-wrapper">
              <div className="pc-age-range-age">
                <div className="text-wrapper">Age: 50+</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/pc/frame-3.svg" alt="Frame" className="img" />
              </div>
            </div>

            <div className="img-2">
              <Image src="/static/image/questionnaire/fasting/ageRange/pc/image-fx-2025-05-22t101223-920-1.png" alt="Image fx" className="image-fx-3" />
            </div>
          </div>
        </div>

        <div className="disclaimer-wrapper">
          <p className="disclaimer">
            <span className="span">
              By choosing your age and continuing you agree to our
            </span>

            <span className="text-wrapper-2">&nbsp;</span>

            <span className="text-wrapper-3"
                onClick={() => {setDisplayNav(TERMS_OF_USE)}}
            >
              Terms of Service
            </span>

            <span className="text-wrapper-2"> | </span>

            <span className="text-wrapper-3"
                onClick={() => {setDisplayNav(PRIVACY_POLICY)}}
            >
              Privacy Policy
            </span>

            <span className="span">&nbsp;</span>

            <span className="text-wrapper-2">| </span>

            <span className="text-wrapper-3" onClick={() => {setDisplayNav(MONEY_BACK_POLICY)}}>Refund Policy</span>

            <span className="text-wrapper-4">&nbsp;</span>

            <span className="span">Please review before continuing</span>
          </p>
        </div>
      </div>
    </div>
  );
};
